import OptimizerEditDto from "./OptimizerEditDto";

export class TrustNCGOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.maxiter = null;
        /** @type {number} */
        this.gtol = null;
        /** @type {number} */
        this.xtol = null;
        /** @type {number} */
        this.tol = null;
        /** @type {number} */
        this.barrier_tol = null
        /** @type {number} */
        this.initial_tr_radius = null
        /** @type {number} */
        this.initial_constr_penalty = null
        /** @type {number} */
        this.initial_barrier_parameter = null
    }

    /**
     * @typedef {Object} _TrustNCGOptimizerEditDtoProps
     * @property {number} maxiter
     * @property {number} gtol
     * @property {number} xtol
     * @property {number} tol
     * @property {number} barrier_tol
     * @property {number} initial_tr_radius
     * @property {number} initial_constr_penalty
     * @property {number} initial_barrier_parameter
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _TrustNCGOptimizerEditDtoProps} TrustNCGOptimizerEditDtoProps
     */
    /**
     * 
     * @param {TrustNCGOptimizerEditDtoProps} props
     * @returns {TrustNCGOptimizerEditDto}
     */
    setup(props) {
        super.setup();

        this.maxiter = props.maxiter;
        this.gtol = props.gtol;
        this.xtol = props.xtol;
        this.tol = props.tol;
        this.barrier_tol = props.barrier_tol;
        this.initial_tr_radius =props.initial_tr_radius;
        this.initial_constr_penalty = props.initial_constr_penalty;
        this.initial_barrier_parameter = props.initial_barrier_parameter;
        return this;
    }
}

export default TrustNCGOptimizerEditDto;